import { render, staticRenderFns } from "./ViewTeacherTrainingTopics.vue?vue&type=template&id=d991d1fa"
import script from "./ViewTeacherTrainingTopics.vue?vue&type=script&lang=js"
export * from "./ViewTeacherTrainingTopics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports